import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-healthcare-diagnostics',
  templateUrl: './healthcare-diagnostics.component.html',
  styleUrls: ['./healthcare-diagnostics.component.scss']
})
export class HealthcareDiagnosticsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}